import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { InTheLab } from './components/InTheLab';
import { Differentiators } from './components/Differentiators';
import { StudioStory } from './components/StudioStory';
import { FeedbackProcess } from './components/FeedbackProcess';
import { LabFaq } from './components/LabFaq';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="2risyes4b16k3">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[2px] focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream" data-id="element-1" data-mp="2mn59mdtqiff4">
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="28u5zysgmvffh" />
      <main id="main" data-id="element-3" data-mp="28tme50nv46w6">
        <Hero data-id="element-4" data-mp="28suu8n3mnxlq" />
        <InTheLab data-id="element-5" data-mp="28skzynbjv4a8" />
        <Differentiators data-id="element-6" data-mp="28s31dk1f0dz5" />
        <StudioStory data-id="element-7" data-mp="23vupcfiil0w7" />
        <FeedbackProcess data-id="element-8" data-mp="23ujkecdc1n3i" />
        <LabFaq data-id="element-9" data-mp="23v2u55stx56g" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3ik7gwiph6frp" />
    </div>;
}